import { Link } from 'gatsby';
import { LeadParagraph } from "../../../../src/components/LeadParagraph";
import * as React from 'react';
export default {
  Link,
  LeadParagraph,
  React
};